export default "__VITE_ASSET__BvZG0tF7__"